module.exports = __webpack_public_path__ + "img/29.6a3f4273.jpg";